import { Component, OnDestroy } from '@angular/core';
import { NavController,ViewController,NavParams,ToastController,AlertController,ModalController,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-editProduct',
  templateUrl: 'editProduct.html'
})
export class EditProductPage implements OnDestroy {
  url: any;
  product: any;
  menu: any;
  alertTitle: any;
  contain: any;
  not_contain: any;
  could_contain: any;
  allergyText: any;
  width: any;
  height: any;
  variants = [];
  //lockedIngredients = false;
  max: any;
  qty = 1;
  cont = 0;
  data: any;
  ingredients = [];
  private _onDestroy = new Subject();
  parentItem = null;
  imageType = '';
  imageTypeS = '';
  imageTypeM = '';
  imageTypeL = '';

  constructor(public navCtrl: NavController,
              public provider: provider,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public modalCtrl: ModalController,
              public platform: Platform,
              public customizer: CustomizerProvider) {


    this.url = provider.getUrl();

    this.data = provider.getMenu();
    this.product = navParams.get('item');
    this.max = this.product.max;
    this.cont = this.product.cont;

    // get product variants from definition
    let productVariants = provider.getCartProductVariants(this.product.prodotto, this.product.varIngr)
    this.parentItem = this.provider.getMenuRow(this.product.prodotto.parent)
    // this.lockedIngredients = (parentItem && parentItem.content.extraProps.mandatoryIngredients)
    
    // copy back result
    this.variants = productVariants.variants
    this.ingredients = productVariants.ingredients

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
      
      this.imageTypeS = this.width/3 + 'px';
      this.imageTypeM = this.width/2 + 'px';
      this.imageTypeL = this.width + 'px';
    });

    this.imageType = this.data.settings.imageType;

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  getUrl(prod) {
    if(this.data.settings.highResImages) {
      return this.url + prod.img;
    } else {
      switch(this.imageType) {
        case 'S':
          return this.url + prod.img + '?h=' + (this.height/4);
        case 'M':
          return this.url + prod.img + '?h=' + (this.height/3);
        case 'L':
          return this.url + prod.img + '?h=' + (this.height/2);
      }
    }
  }

  getImgAllergene(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  getAllergy(alg) {
    return this.url + '/' + alg + '?w=50'
  }

  /**
   * Add main item quantity
   */
  addQty() {
    this.product.quantita++;
  }

  /**
   * Remove main item quantity
   */
  removeQty() {
    if(this.product.quantita > 1) {
      this.product.quantita--;
    }
  }

  /**
   * Increase variant/ingredient quantity
   * @param item item to manipulate
   */
  increaseQty(item) {
    if (item.quantita < 0) {
      item.quantita++;
      this.cont--;
    }
    else {
      if (this.cont != this.max) {
        item.quantita++;
        this.cont++;
      }
      else {
        this.showAlert();
      }
    }
  }

  /**
   * Decrease variant/ingredient quantity
   * @param item item to manipulate
   */
  decreaseQty(item) {
    if (item.quantita <= 0) {
      if (this.cont != this.max) {
        item.quantita--;
        this.cont++;
      }
      else {
        this.showAlert();
      }
    }
    else {
      item.quantita--;
      this.cont--;
    }
  }

  //allergie
  showAllergy(allergy) {
    let text,contain,allergyText;

    this.translateService.get('CONTIENE').takeUntil(this._onDestroy).subscribe(value => { contain = value });
    this.translateService.get(allergy).takeUntil(this._onDestroy).subscribe(value => { allergyText = value });

    text = '<img src="assets/ALLERGENI/' + allergy + '.png"><br><h2>' + contain + '<br><b>' + allergyText + '</b></h2>';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  //visualizzazione immagine variante/ingrediente
  showImage(varingr) {
    console.log(varingr)
    let img = this.url + varingr.img;
    let text = '<h2>' + this.provider.renderDescr(varingr) + '</h2><p>' + this.provider.renderDescrEstesa(varingr) + '</p><br><img src="' + img + '">';

    let alert = this.alertCtrl.create({
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  //varianti
  showAlert() {
    let alert = this.alertCtrl.create({
      title: 'Errore, limite raggiunto!',
      subTitle: 'Non puoi aggiungere altre varianti!',
      buttons: ['OK']
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  //aggiungere al carrello il prodotto
  sendData(prod) {

    // sort variants and ingredients
    prod.varIngr = this.provider.sortCartItemVariants({ ingredients: this.ingredients, variants: this.variants })

    this.provider.updateCartItem(prod);
    this.viewCtrl.dismiss();
  }

  readMore(descr) {
    let text;

    text = this.provider.renderDescrEstesa(descr);

    let alert = this.alertCtrl.create({
      title: 'Informazioni',
      message: text,
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/editProduct/editProduct.ts